<svelte:head>
    <title>The Phoenix Pages</title>
</svelte:head>

<div id="main" class="flex flex-col items-center justify-start flex-1 w-full max-h-full overflow-hidden"> 
    <section class="flex-1 w-full max-h-full px-6 py-3 overflow-hidden lg:p-12">
        <div class="flex flex-col items-center justify-center w-full h-full max-h-full overflow-hidden lg:flex-row shadow-elevate-lg rounded-2xl">
            <h1 class="text-6xl">Coming Soon&trade;!</h1>
        </div>
    </section>
</div>